import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckMedium = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.9069 3L6.2669 9.614L3.3239 6.633L1.8999 8.038L6.2529 12.447L14.3159 4.418L12.9069 3Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgCheckMedium);
export { ForwardRef as ReactComponent };
